<template>
  <v-container>
    <v-card>
      <v-toolbar flat>
        <v-dialog v-model="dateModal" persistent width="290px">
          <template v-slot:activator="{ on }">
            <div style="width: 270px">
              <v-text-field
                :loading="$apollo.loading"
                prepend-inner-icon="mdi-calendar-range"
                hide-details
                v-model="dateRangeText"
                readonly
                v-on="on"
                filled
                rounded
                dense
              ></v-text-field>
            </div>
          </template>
          <v-date-picker
            first-day-of-week="1"
            locale="sv"
            v-model="dates"
            range
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="cancelDate">Avbryt</v-btn>
            <v-btn
              text
              color="primary"
              :disabled="dates.length < 2"
              @click="confirmDate"
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>

        <v-spacer />
        <v-btn @click="exportExcel" rounded class="mr-4">
          Exportera till Excel
          <v-icon small right>mdi-file-export-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <canvas ref="chart"></canvas>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import GET_PRODUCTION from '@/gql/production/queries/GetProduction.gql'
import Chart from 'chart.js'
import { format, addDays, isAfter } from 'date-fns'
import { exportExcel } from '@/services/export-excel-service.js'

export default {
  name: 'BusinessIntelligenceFoundInquiriesResolved',

  data() {
    return {
      production: [],
      dateModal: false,
      interval: {
        start: format(addDays(new Date(), -30), 'yyyy-MM-dd'),
        end: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
      },
      chart: null,
      dates: [],
    }
  },

  apollo: {
    production: {
      query: GET_PRODUCTION,
      manual: true,
      result({ data }) {
        if (!data) return
        this.production = data.production
        this.setChartData(data.production)
      },
      variables() {
        return {
          filter: {
            interval: {
              start: this.interval.start,
              end: this.interval.end,
            },
          },
        }
      },
    },
  },

  created() {
    this.dates = [this.interval.start, this.interval.end]
  },

  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'bar',
      data: {},
      options: {
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    })
  },

  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
  },

  methods: {
    cancelDate() {
      this.dates = [this.interval.end, this.interval.start]
      this.dateModal = false
    },

    confirmDate() {
      const firstIsAfter = isAfter(
        new Date(this.dates[0]),
        new Date(this.dates[1]),
      )
      this.interval.start = firstIsAfter ? this.dates[1] : this.dates[0]
      this.interval.end = firstIsAfter ? this.dates[0] : this.dates[1]

      this.dateModal = false
    },

    setChartData(data) {
      this.chart.data = {
        labels: data.map(x => format(new Date(x.identifier), 'dd-MMM')),
        datasets: [
          {
            data: data.map(x => x.found),
            label: 'Upphittade',
            backgroundColor: '#0066ff',
          },
          {
            data: data.map(x => x.inquiries),
            label: 'Förfrågningar',
            backgroundColor: '#ff4800',
          },
          {
            data: data.map(x => x.resolved),
            label: 'Utlämnat',
            backgroundColor: '#00e7c8',
          },
        ],
      }

      this.chart.update()
    },

    exportExcel() {
      const filename = `Upphittade-Förfrågningar-Utlämnat`

      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'data',
            data: this.production.map(row => {
              return {
                Datum: row.identifier,
                Upphittade: row.found,
                Förfrågningar: row.inquiries,
                Utlämnat: row.resolved,
              }
            }),
          },
        ],
      }

      exportExcel(filename, workbook)
    },
  },
}
</script>
